<div class="toastr-container">
    <img
        src="/assets/images/toastr/toastr-error.png"
        alt="Error"
        class="toastr-icon"
    />
    <span class="toastr-message" [innerHTML]="message">
    </span>
    <button
        class="toastr-dismiss"
        (click)="closeToast()"
        [attr.aria-label]="'text.dismiss' | translate"
    >
        <img
            src="/assets/images/cross_white.svg"
            alt=""
            class="toastr-dismiss-icon"
        />
    </button>
</div>